<script lang="ts" setup>
const keretaStore = useTrainStore();
const userStrore = useUserStore();
import Swal from "sweetalert2";
const localStorageStore = useLocalStorageStore()
// import type { listStations } from "~/istypes";

const from = ref('');
const to = ref('');
const tgl_dep = ref();
const tgl_ret = ref();
const adt = ref(1);
const inf = ref(0);
const trip  = ref('O');
const loading = ref(false);
const adtOptions = ref<number[]>([]);
const infOptions = ref<number[]>([0, 1]);
const stationsList = ref<any>([]);
const selectedStationFrom = ref<any | null>(null);
const selectedStationTo = ref<any | null>(null);
const isRoundTrip = ref(false);

const toggleRoundTrip = () => {
  if (isRoundTrip.value) {
    selectTrip('R')
  } else {
    selectTrip('O')
  }
}

const getStation =  async() => {
  try{
    const response: any =  localStorageStore.getStations();
    stationsList.value = response?.filter((station: any) => station.status === 1);
  }catch(error){
    console.error(error)
  }
}

const selectTrip = (type: any) => {
  trip.value = type;
}

const checkSchedule = async() => {
  try{
    // const tripValue = trip.value === 'Pulang Pergi' ? 'R' : 'O';
    loading.value = true;

    const response:any = await keretaStore.getSchedule({
      org: selectedStationFrom.value.code,
      des:selectedStationTo.value.code,
      trip: trip.value,
      tgl_dep: tgl_dep.value,
      tgl_ret : tgl_ret.value,
      adt: adt.value,
      chd : 0,
      inf: inf.value,
    })

    // get selectedschedule
    const getSelectedDep = localStorage.getItem('selectedDeparture');
    const getSelectedRet = localStorage.getItem('selectedReturning')
    if(getSelectedDep || getSelectedRet){
      // remove data
      localStorage.removeItem("selectedDeparture");
      localStorage.removeItem("selectedReturning");
    }
    if(response?.status.code == 200){
      navigateTo('/trains/schedule');
      localStorage.setItem('queries', JSON.stringify(response.details.queries));
    }else if(response?.status.code == 400){
      const errorMessages = response?.status.message;


      if (errorMessages && (typeof errorMessages === 'string' || errorMessages instanceof String)) {
        // Scenario 1 and 3
        Swal.fire({
          title: errorMessages.toString(),
          icon: 'warning',
        });
      } else if (errorMessages && (Array.isArray(errorMessages) || typeof errorMessages === 'object')) {
        // Scenario 2
        let errorMessageString = '';
        if (Array.isArray(errorMessages)) {
          errorMessageString = errorMessages.join('\n');
        } else {
          Object.keys(errorMessages).forEach((field) => {
          const fieldErrors = errorMessages[field];
          if (Array.isArray(fieldErrors)) {
            errorMessageString += `<strong>${field}:</strong> ${fieldErrors.join(', ')}<br>`;
          } else if (typeof fieldErrors === 'object') {
            Object.keys(fieldErrors).forEach((nestedField) => {
              const nestedErrors = fieldErrors[nestedField];
              errorMessageString += `<strong>${nestedField}:</strong> ${nestedErrors.join(', ')}<br>`;
            });
          }
        });
        }


        Swal.fire({
          title: 'Kesalahan Validasi',
          html: errorMessageString,
          icon: 'warning',
        });
      } else {
        console.error('Unexpected error response format');
      }
    }
  }catch(error){
    console.error(error)
  }finally {
    loading.value = false; 
  }
}

const getCurrentDate = () =>  {
  const currentDate = new Date();
  const year: number = currentDate.getFullYear();

  let month: number | string = currentDate.getMonth() + 1;
  month = month < 10 ? `0${month}` : month;

  let day: number | string = currentDate.getDate();
  day = day < 10 ? `0${day}` : day;

  return `${year}-${month}-${day}`;
};


onMounted(() => {
  getStation();
});

watch(adt, () => {
  if (!inf.value && inf.value !== 0) {
    inf.value = 0;
  }

  if (adt.value > 1) {
    infOptions.value = Array.from({ length: adt.value }, (_, index) => index + 1);
    if (inf.value > adt.value) {
      inf.value = adt.value;
    }
  } else {
    infOptions.value = [0, 1];
    if (inf.value > 1) {
      inf.value = 1;
    }
  }
});

const swapValues = () => {
  const temp = { ...selectedStationFrom.value };
  selectedStationFrom.value = { ...selectedStationTo.value };
  selectedStationTo.value = { ...temp };
};

</script>
<template>
  <Customloading  v-if="loading" />
    <div class="">
      <div class="form mx-2">
        <div class="my-3">
          <div class="row mb-3 mb-0-sm">
            <div class="col-12 col-lg-8 col-md-8">
              <div class="d-flex d-flex-sm">
                <div class="col">
                  <label for="">Dari</label>
                  <StationSelect
                    v-model="selectedStationFrom"
                    placeholderText="Pilih Stasiun Asal"
                    menuWidth="17rem"
                  />
                </div>
                <div class="mt-4 mx-2 text-center-sm mt-0-sm">
                  <div class="swap-button">
                    <button class="btn btn-primary" @click="swapValues">
                      <i class="fa-solid fa-repeat"></i>
                    </button>
                  </div>
                </div>
                <div class="col">
                  <label for="">Ke</label>
                  <StationSelect
                    v-model="selectedStationTo"
                    placeholderText="Pilih Stasiun Tujuan"
                    menuWidth="17rem"
                  />
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-4 col-md-4 mb-3">
              <label for="">Jumlah Penumpang</label>
              <button class="form-select rounded text-start" type="button" id="trip" data-bs-toggle="dropdown" aria-expanded="false">{{ `${adt} Dewasa` }}{{ chd > 0 ? `, ${chd} Anak` : '' }}{{ inf > 0 ? `, ${inf} Bayi` : '' }}</button>
                <ul class="dropdown-menu p-2" aria-labelledby="trip" @pointerdown.stop @click.stop>
                  <div class="mx-2 my-3">
                    <div class="row mt-3">
                      <div class="col col-lg-6 col-md-6">
                        <label>Dewasa</label><br>
                        <small class="pb-3" style="font-size: 10px;">(diatas 3 tahun)</small>
                      </div>
                      <div class="col col-lg-6 col-md-6">
                        <InputNumber v-model="adt" :min="1" :max="9" />
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col col-lg-6 col-md-6">
                        <label>Bayi</label><br>
                        <small class="pb-3" style="font-size: 10px;">(dibawah 3 tahun)</small>
                      </div>
                      <div class="col col-lg-6 col-md-6">
                        <InputNumber v-model="inf" :min="0" :max="adt" />
                      </div>
                    </div>
                  </div>
                </ul>
            </div>
          </div>
          <div class="row mb-3 mb-0-sm">
            <div class="col-12 col-lg-3 col-md-3 mb-3">
              <label for="">Tanggal Pergi</label>
              <dateInput v-model="tgl_dep" />
            </div>
            <div class="col-12 col-lg-3 col-md-3 mb-3">
              <input type="checkbox"  style="transform: scale(1.5);" name="tanggal_pulang" v-model="isRoundTrip" @change="toggleRoundTrip"><label style="margin-left: 5px;" for="tanggal_pulang">Tanggal Pulang</label>
              <dateInput v-model="tgl_ret" :minDate="tgl_dep" :disabled="!isRoundTrip"/>
            </div>
            <div class="col-12 col-lg-3 col-md-3">
              <div class="col">
                <button
                  type="button"
                  class="btn fw-semibold text-white mt-4"
                  style="width: 100%; background-color: #fb8b34"
                  @click="checkSchedule"
                >
                  Cari Tiket
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<style scoped>
</style>